(function () {
    'use strict';

    var testApp = angular
        .module('invesfleet')
        .controller('misfichajesController', misfichajesController);


    misfichajesController.$inject = [
        '$stateParams', 'genericDataService', '$rootScope', '$state',
        '$filter', '$q', '$scope', 'notificationService', 'logEmpleadosService', 'common', 'reportingService', 'userService', 'modals'
    ];


    function misfichajesController($stateParams, genericDataService, $rootScope, $state,
        $filter, $q, $scope, notificationService, logEmpleadosService, common, reportingService, userService, modals) {

        /* PUBLIC VARIABLES */
        var vm = this;
        vm.changeTab = changeTab; 
        vm.selectAll = selectAll; 
        vm.selectOne = selectOne; 
        vm.expandPendientes = expandPendientes;
        vm.aprobar = aprobar; 
        vm.goToEdit = goToEdit; 
        vm.filterAccepted = filterAccepted;
         vm.showRechazar = showRechazar;
         vm.rechazarCallback = rechazarCallback;
         vm.addObservacion = addObservacion; 
        vm.actualize = actualize; 
        vm.finalizadasSign = '-'; 
        vm.rechazadasSign = '-';
        vm.itemRechazado = {}; 
        vm.loadedAcepted = true;


        vm.selectedNum = 0;
           vm.meses = {
               list: [{
                   id: 0,
                   nombre: 'Enero'
               }, {
                   id: 1,
                   nombre: 'Febrero'
               }, {
                   id: 2,
                   nombre: 'Marzo'
               }, {
                   id: 3,
                   nombre: 'Abril'
               }, {
                   id: 4,
                   nombre: 'Mayo'
               }, {
                   id: 5,
                   nombre: 'Junio'
               }, {
                   id: 6,
                   nombre: 'Julio'
               }, {
                   id: 7,
                   nombre: 'Agosto'
               }, {
                   id: 8,
                   nombre: 'Septiembre'
               }, {
                   id: 9,
                   nombre: 'Octubre'
               }, {
                   id: 10,
                   nombre: 'Noviembre'
               }, {
                   id: 11,
                   nombre: 'Diciembre'
               }],
               selected: {
                   id: 1,
                   nombre: 'Enero'
               }
           };
           vm.anos = {
               list: [],
               selected: 0
           };

        vm.charged = false; 
        vm.tabNumber = 1; 
        vm.pending = []; 
        vm.accepted = []; 
        vm.chargedAccepted = false; 
        vm.aprovacionNum = 0; 
        vm.aceptacionNum = 0; 
        vm.allAprovacion = false; 
        vm.supervisor = userService.userData.usuarioId;
        vm.loaded = false; 
        vm.rechazar = rechazar; 

        (function () {
            loadData();
        })();

        function loadData() {
            if (userService.userData.empresamaster.contrataControlHorario != true) $state.go('flota.controlHorario.activarControlHorario');
            else if(userService.userData.empleado.activarControlHorario != true) {
                // sendErrorNotification("No tiene activado el control horario!");
                var tab = $rootScope.tabManager.tabs.find(x=> x.name == 'misfichajes'); 
                if(tab != null) {
                    $rootScope.tabManager.remove(tab); 
                    $rootScope.$broadcast('checkExitAction' + tab.state);
                }
                $state.go('flota.empleados');
            }

            logEmpleadosService.getJornadasEmpleado().then(function (response) {
                vm.pending = response; 
                for(var i = 0; i<vm.pending.length; i++) {
                    vm.pending[i].selected = false; 
                }
                vm.rechazadasNum = vm.pending.filter(x=>x.estado == 4).length; 
                vm.finalizadasNum = vm.pending.filter(x => x.estado == 1).length;
                vm.aprovacionNum = vm.pending.filter(x => x.estado == 2).length;

                if($stateParams.tabNumber != null || $stateParams.tabNumber != undefined) {
                    vm.changeTab($stateParams.tabNumber);
                }
                vm.loaded = true; 
            });
        }

        function sendErrorNotification(msg) {
            notificationService.sendAppNotification({
                message: msg,
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'info'
            });
        }
        
         function actualize() {
            vm.loaded = false;
             vm.chargedAccepted = false; 
             loadData();
         }

        function filterAccepted() {
            if (vm.meses.selected == null || vm.anos.selected == null) {
                sendErrorRequire('Los filtros no están completos!');
            } else {
                vm.loadedAcepted = false;
                var date = new Date(vm.anos.selected.id, vm.meses.selected.id);
                logEmpleadosService.getAccepted(date, userService.userData.empleadoId, 0).then(function (response) {
                    vm.accepted = response.data; 
                    for(var i = 0; i < vm.accepted.length; i++) {
                        vm.accepted[i].sign = '-'; 
                    }
                    vm.loadedAcepted = true;
                });
            }
        }

        function sendErrorRequire(messageValue) {
            notificationService.sendAppNotification({
                message: messageValue,
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'error'
            });
        }

        function changeTab(idx) {
            vm.tabNumber = idx; 
            if(idx == 3 && vm.chargedAccepted == false) {
                vm.chargedAccepted = true; 
                setYearsCombo();
                vm.anos.selected = vm.anos.list.find(x => x.id == ((new Date().getFullYear())));
                // vm.meses.selected = vm.meses.list.find(x => x.id == ((new Date().getMonth() == 0 ? 12 : (new Date().getMonth() - 1))));
                vm.meses.selected = vm.meses.list.find(x => x.id == ((new Date().getMonth())));
                filterAccepted();
            }
        }

        function setYearsCombo() {
            for (var i = 2016; i < 2100; i++) {
                vm.anos.list.push({
                    id: i,
                    nombre: i.toString()
                });
            }
        }

        function goToEdit(item) {
            $rootScope.tabManager.tabs.splice($rootScope.tabManager.tabs.findIndex(x => x.title == 'Mis fichajes'), 1);

            $state.go('flota.controlHorario.detalleMiJornada', {
                'id': item.registroJornadaId,
                'tabNumber': vm.tabNumber
            });
        }

        function aprobar(item) {
            var lista = []; 
            if(item == null) {
                for(var i = 0; i < vm.pending.length; i++) {
                    if(vm.pending[i].selected == true) lista.push(vm.pending[i].registroJornadaId);
                }
            }
            else {
                lista.push(item.registroJornadaId);
            } 
            logEmpleadosService.aceptarJornadas(lista).then(function(){
                vm.loaded = false
                vm.chargedAccepted = false;
                vm.selectedNum = 0; 
                loadData();
            });
        }


        function selectAll(idx) {
            if(idx == 1) {
                if(vm.allAprovacion == false) {
                    vm.allAprovacion = true; 
                    for(var i = 0; i < vm.pending.length; i++) {
                        if(vm.pending[i].estado == 2) {
                            if (vm.pending[i].selected == false) vm.selectedNum++;
                            vm.pending[i].selected = true;
                        } 
                    }
                }
                else {
                    vm.allAprovacion = false;
                    for (var i = 0; i < vm.pending.length; i++) {
                        if (vm.pending[i].estado == 2) {
                            if (vm.pending[i].selected == true) vm.selectedNum--;
                            vm.pending[i].selected = false;
                        } 
                    }
                }
            }
        }

        function selectOne(option) {
            if(option.selected == true) {
                option.selected = false; 
                vm.selectedNum--; 
            }
            else if(option.selected == false) {
                option.selected = true; 
                vm.selectedNum++; 
            } 

        }

        function expandPendientes(idx) {
            if(idx == 1) {
                if(vm.finalizadasSign == '-') {
                    vm.finalizadasSign = '+'; 
                }
                else {
                    vm.finalizadasSign = '-';
                }
            }
            else if (idx == 2) {
                if (vm.rechazadasSign == '-') {
                    vm.rechazadasSign = '+';
                } else {
                    vm.rechazadasSign = '-';
                }
            }
        }

         function showRechazar() {
             modals.showModal('anadirObservacion', vm.rechazarCallback);
         }

         function rechazarCallback(observacion) {
             if (observacion != '') {
                 vm.itemRechazado.observacionesParsed = {}; 
                 parseObservaciones(vm.itemRechazado.observacionesParsed, vm.itemRechazado.observaciones);
                 vm.itemRechazado.observacionesParsed.add = observacion;
                 vm.addObservacion(vm.itemRechazado.observacionesParsed);
                vm.itemRechazado.observaciones = JSON.stringify(vm.itemRechazado.observacionesParsed.list);
             }

             logEmpleadosService.rechazarJornada(vm.itemRechazado.registroJornadaId, vm.itemRechazado.observaciones).then(function () {
                 vm.loaded = false
                 loadData();
             });
         }
        function rechazar(item) {
            vm.itemRechazado = item; 
            vm.showRechazar()
           
        }

        function addObservacion(obs) {
            if (!obs.add) {
                return;
            }
            obs.list.push({
                text: obs.add,
                time: Date.now(),
                author: userService.userData.name ? userService.userData.name : '' +
                    (userService.userData.surname ? ' ' + userService.userData.surname : '')
            });
            obs.add = null;
        }

        function parseObservaciones(obs, data) {
            if (data == null) {
                obs.list = [];
            } else {
                try {
                    obs.list = JSON.parse(data);
                } catch (e) {
                    data = JSON.stringify([{
                        text: data
                    }]);
                    obs.list = JSON.parse(data);
                }
            }
        }


    }
})();
